import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import Config from '../../../../Config';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {saveToHistory, stepEnum} from '../IMEIDeviceRepairSlice';
import {gtag4} from '../../../../utilities/analytics/tracking';
import {
  dwhPrivateGeneralErrorScreenDisplayed
} from "app/Components/Block/IMEIDeviceRepairBlock/reports/dwhReports";
const ErrorComponent = (props) => {
  const {selectedAccountOrgName, selectedIMEI, deliveryPrice, causeList, alternatePhone, securityCode} = props.deviceRepairData;

  const selectedHetPay = props.portalState.selectedHetPay;
  const customerName = props.loginData.userDetails.firstName + ' ' + props.loginData.userDetails.lastName;
  const subscriber = props.loginData.userDetails.contactNumber;

  useEffect(() => {
    if (props.deviceRepairData.currentStep == stepEnum.ERROR) {
      gtag4({
        event: 'DeviceRepair_ErrorPage',
        action: 'ErrorPage',
        error: 'אופס, משהו השתבש. יש לפנות לאחראית השירות להמשך טיפול',
      });
      if (props.contentData.isFromPrivateSelfcare.value) {
        dwhPrivateGeneralErrorScreenDisplayed({selectedHetPay, subscriber, selectedIMEI, causeList, alternatePhone, securityCode, deliveryPrice, customerName, selectedAccountOrgName})
      }
      }

    props.saveToHistory('error');
  }, []);

  if (typeof window.scrollTo === 'function') {
    window.scrollTo(0, 0);
  }
  let getTitle = () => {
    let title;
    switch (props.deviceRepairData.currentStep) {
      case stepEnum.ERROR:
        title = props.numberCallCenter;
        break;
      case stepEnum.IS_LOCKED_FAILED:
        title = ' רק רגע, הפעולה לא הושלמה';
        break;
    }
    return title;
  };

  let getDescription = () => {
    let description;
    switch (props.deviceRepairData.currentStep) {
      case stepEnum.ERROR:
        description = 'יש לפנות לאחראית השירות להמשך טיפול';
        break;
      case stepEnum.IS_LOCKED_FAILED:
        description = (
          <>
            {
              <>
                <div>כדי שנוכל לתאם את השליחות יש לכבות שירות "מצא את האייפון שלי"</div>
                <div>
                  <span className='bold'>שימו לב: </span>
                  לא נוכל לבצע תיקון במידה והשירות עדיין פעיל בנייד
                </div>
                <div>
                  להסבר כיצד לכבות את האפליקציה "מצא את האייפון שלי" (find my iPhone),{' '}
                  <a href='https://support.apple.com/he-il/HT211149' target='_blank' className='cellcom-color'>
                    לחצו כאן{' '}
                  </a>
                </div>
              </>
            }
          </>
        );
        break;
    }
    return description;
  };

  async function buttonFunction() {
    var content = await props.context.loadContentByPath(Config.businessLobbyUrl);
    props.context.navigateTo(content);
  }
  return (
    <Container className='imei-failure-container'>
      <Row>
        <Col className='image'>
          <svg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'>
            <g transform='rotate(2 -449.854 493.004)' fill='none' fillRule='evenodd'>
              <g transform='translate(0 11.454)'>
                <rect stroke='#000' strokeWidth='4' x='2' y='18.546' width='86' height='52' rx='9' />
                <path
                  d='m45.058 0 .266.006a8.964 8.964 0 0 1 6.366 2.973L67.5 20.546h-45L38.31 2.979A8.975 8.975 0 0 1 44.793.002L45.058 0zm-3.435 5.313-.173.166-.167.176-9.801 10.89h27.037l-9.803-10.89a5 5 0 0 0-.18-.19l-.191-.182a5 5 0 0 0-6.722.03z'
                  fill='#000'
                  fillRule='nonzero'
                />
              </g>
              <circle fill='var(--theme-primary, #810ea9)' cx='45.5' cy='9' r='9' />
              <path
                d='M42.755 45.264a2.407 2.407 0 0 1 1.492 2.218v1.583c7.705.589 13.677 6.901 13.753 14.539a13.763 13.763 0 0 1-.424 3.368 1.364 1.364 0 0 1-1.232 1.025l-.117.002-.115-.002a1.364 1.364 0 0 1-1.232-1.025c-1.263-4.945-5.538-8.568-10.674-9.048v1.514c0 .969-.589 1.843-1.492 2.218-.979.445-2.13.28-2.942-.419l-6.925-5.964A2.369 2.369 0 0 1 32 53.46c0-.697.31-1.36.847-1.812l6.925-5.978a2.763 2.763 0 0 1 2.983-.406z'
                fill='var(--theme-primary, #810ea9)'
                fillRule='nonzero'
              />
            </g>
          </svg>
        </Col>
      </Row>

      <Row className='justify-content-md-center error-title'>
        <Col xs={12}>
          <Row className={`d-block ${isMobile ? 'fs-24' : 'fs-36'}`}>{getTitle()}</Row>
        </Col>
      </Row>

      <Row className='justify-content-md-center error-description'>
        <Col xs={12}>
          <Row className={`d-block fs-24`}>{getDescription()}</Row>
        </Col>
      </Row>

      <Row className='justify-content-md-center'>
        <Col xs={12}>
          <BtnWhiteBlackBorderBigSize
            formid='failure-screen'
            onclick={() => buttonFunction()}
            text='חזרה לאיזור האישי'></BtnWhiteBlackBorderBigSize>
        </Col>
      </Row>
    </Container>
  );
};
const mapStateToProps = (state) => {
  return {
    deviceRepairData: state.iMEIDeviceRepair,
    portalState: state.portalsBlock,
    loginData: state.authentication.loginData
  };
};

const mapDispatchToProps = {
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorComponent);
